export default function buildHierarchy(contents = []) {
  const map = {};
  const roots = [];

  // Sort numeric-aware
  const sorted = contents
    .filter((c) => c?.content_id)
    .sort((a, b) =>
      a.content_id.localeCompare(b.content_id, undefined, { numeric: true })
    );

  for (const item of sorted) {
    const id = item.content_id.trim();
    const parts = id.split(".");
    const parentKey = parts.slice(0, -1).join(".");

    // Ensure map entry
    if (!map[id]) map[id] = { ...item, children: [] };
    else map[id] = { ...map[id], ...item };

    // Auto-create parent placeholders
    if (parentKey && !map[parentKey]) {
      map[parentKey] = {
        content_id: parentKey,
        title: `Module ${parentKey}`,
        subject: item.subject,
        video_link: "NA",
        content_text: "",
        children: [],
        isPlaceholder: true,
      };
    }

    // Attach to parent or root
    if (parentKey) {
      map[parentKey].children.push(map[id]);
    } else {
      roots.push(map[id]);
    }
  }

  // Sort recursively for display
  const sortRecursively = (nodes) => {
    nodes.sort((a, b) =>
      a.content_id.localeCompare(b.content_id, undefined, { numeric: true })
    );
    nodes.forEach((n) => {
      if (n.children?.length) sortRecursively(n.children);
    });
  };

  sortRecursively(roots);
  return roots;
}
